import { ReactElement } from 'react';
import PageScoller, { PageScollerProps } from './components/PageScroller';
import React from 'react';

const Home = React.forwardRef((props: PageScollerProps, ref): ReactElement => {
    const { initialPageIndex, onChangeScroll } = props;
    return <>{<PageScoller initialPageIndex={initialPageIndex} onChangeScroll={onChangeScroll} ref={ref} />}</>;
});

export default Home;
